import React from 'react';
import styled from '@emotion/styled';
import config from '../../config';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import ButtonBase from '@mui/material/ButtonBase';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const StyledComponent = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;

  button {
    /* background: rgba(0,0,0,0.1); */
    background: transparent;
    color: var(--contact-btn-border);
    border: none;
    border-radius: 20px;
    padding: 1px 3px;
    margin: 1px 2px;
    cursor: pointer;
  }

  h2 {
    padding: 0;
  }
`;

const StyledDisclaimer = styled(Dialog)(({ w }) => (`
  position: absolute;
  bottom: 0;
  right: 0;
  

  .MuiPaper-root {
    background-color: var(--content-background-color);
    backdrop-filter: blur(20px);
    border-radius: 20px !important;
    color: var(--ex-primary-text-color) !important;
    ${w ? `width: ${w};` : ''}
   
    &::-webkit-scrollbar {
        display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`));

// Helper function that formats the humans.txt text.
const formatCreditsText = (text) => {
    // Replace comment blocks (e.g., "/* TEAM */") with bold text.
    const withBoldComments = text.replace(/\/\*([^*]+)\*\//g, '<strong>$1</strong>');
    // Replace newline characters with <br/> tags.
    return withBoldComments.replace(/\n/g, '<br/>');
};

const Disclaimer = () => {
    const [open, setOpen] = React.useState(false);
    const [creditsOpen, setCreditsOpen] = React.useState(false);
    const [creditsText, setCreditsText] = React.useState("");

    const toggleOpen = () => setOpen(!open);
    const toggleCreditsOpen = () => setCreditsOpen(!creditsOpen);

    React.useEffect(() => {
        fetch('/humans.txt')
            .then(response => response.text())
            .then(text => {
                // Format the fetched text so that comments are bold and newlines become <br/>.
                const formattedText = formatCreditsText(text);
                setCreditsText(formattedText);
            });
    }, []);

    return (
        <StyledComponent>
            <StyledDisclaimer open={open} onClose={toggleOpen}>
                <ButtonBase
                    onClick={toggleOpen}
                    sx={{
                        position: 'absolute',
                        top: 10,
                        right: 15,
                        color: "var(--ex-primary-text-color)",
                        padding: 0,
                        borderRadius: 10
                    }}
                >
                    <span style={{
                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                        borderRadius: "50%",
                        width: "25px",
                        height: "25px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CloseRoundedIcon sx={{ fontSize: '1.25rem' }} />
                    </span>
                </ButtonBase>
                <DialogTitle>Legal</DialogTitle>
                <div
                    dangerouslySetInnerHTML={{ __html: config.meta.disclaimer_html }}
                    style={{ color: "var(--ex-primary-text-color)", padding: 25 }}
                />
            </StyledDisclaimer>

            <StyledDisclaimer open={creditsOpen} onClose={toggleCreditsOpen} w="50%">
                <ButtonBase
                    onClick={toggleCreditsOpen}
                    sx={{
                        position: 'absolute',
                        top: 10,
                        right: 15,
                        color: "var(--ex-primary-text-color)",
                        padding: 0,
                        borderRadius: 10
                    }}
                >
                    <span style={{
                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                        borderRadius: "50%",
                        width: "25px",
                        height: "25px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CloseRoundedIcon sx={{ fontSize: '1.25rem' }} />
                    </span>
                </ButtonBase>
                <DialogTitle>Credits</DialogTitle>
                <div
                    dangerouslySetInnerHTML={{ __html: creditsText }}
                    style={{
                        color: "var(--ex-primary-text-color)",
                        paddingLeft: 25,
                        paddingRight: 25,
                        paddingTop: 0,
                        paddingBottom: 25,
                    }}
                />
            </StyledDisclaimer>

            <button onClick={toggleOpen}>Legal</button>
            <button onClick={toggleCreditsOpen}>Credits</button>
        </StyledComponent>
    );
};

export default Disclaimer;
